import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { API } from '../api';
import Layout from '../components/Layout';

const STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Syne:wght@600;700;800&family=DM+Sans:wght@300;400;500;600&display=swap');
  @keyframes fadeSlideIn{from{opacity:0;transform:translateY(20px)}to{opacity:1;transform:translateY(0)}}
  @keyframes modalIn{from{opacity:0;transform:scale(0.94) translateY(16px)}to{opacity:1;transform:scale(1) translateY(0)}}
  @keyframes rowIn{from{opacity:0;transform:translateX(-10px)}to{opacity:1;transform:translateX(0)}}
  @keyframes spin{to{transform:rotate(360deg)}}
  @keyframes shimmer{0%{background-position:-600px 0}100%{background-position:600px 0}}
  @keyframes pulse{0%,100%{box-shadow:0 0 0 0 rgba(99,179,237,0.4)}50%{box-shadow:0 0 0 8px rgba(99,179,237,0)}}
  *{box-sizing:border-box}
  .cp-root{font-family:'DM Sans',sans-serif;animation:fadeSlideIn 0.5s ease both}
  .cp-select{width:100%;padding:11px 14px;background:#f8faff;border:1.5px solid #e2e8f5;
    border-radius:12px;color:#1a1d2e;font-size:14px;font-family:'DM Sans',sans-serif;
    outline:none;cursor:pointer;appearance:none;
    background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath d='M1 1l5 5 5-5' stroke='%2363b3ed' stroke-width='2' fill='none'/%3E%3C/svg%3E");
    background-repeat:no-repeat;background-position:right 14px center;
    transition:border-color 0.2s,box-shadow 0.2s}
  .cp-select:focus{border-color:#63b3ed;box-shadow:0 0 0 3px rgba(99,179,237,0.15)}
  .cp-select:disabled{background:#f0f0f0;color:#a0aec0;cursor:not-allowed}
  .cp-input{width:100%;padding:11px 14px;background:#f8faff;border:1.5px solid #e2e8f5;
    border-radius:12px;color:#1a1d2e;font-size:14px;font-family:'DM Sans',sans-serif;
    outline:none;transition:border-color 0.2s,box-shadow 0.2s,background 0.2s}
  .cp-input:focus{border-color:#63b3ed;background:#fff;box-shadow:0 0 0 3px rgba(99,179,237,0.15)}
  .cp-input::placeholder{color:#a0aec0}
  .cp-input.small{padding:8px 10px;font-size:13px;text-align:center;border-radius:8px}
  .cp-input.small:focus{border-color:#63b3ed;box-shadow:0 0 0 2px rgba(99,179,237,0.15)}
  .cp-btn-primary{padding:12px 26px;background:linear-gradient(135deg,#63b3ed,#4299e1);
    border:none;border-radius:12px;color:#fff;font-size:14px;font-weight:700;
    font-family:'DM Sans',sans-serif;cursor:pointer;transition:transform 0.15s,box-shadow 0.15s;
    display:inline-flex;align-items:center;gap:8px}
  .cp-btn-primary:hover{transform:translateY(-2px);box-shadow:0 8px 20px rgba(66,153,225,0.4)}
  .cp-btn-primary:disabled{opacity:0.6;cursor:not-allowed;transform:none}
  .cp-btn-secondary{padding:11px 22px;background:#f0f4ff;border:1.5px solid #e2e8f5;
    border-radius:12px;color:#4a5568;font-size:14px;font-weight:600;
    font-family:'DM Sans',sans-serif;cursor:pointer;transition:all 0.15s}
  .cp-btn-secondary:hover{background:#e8eeff;border-color:#63b3ed;color:#3182ce}
  .cp-row:hover td{background:#f0f7ff !important;transition:background 0.15s}
  .action-btn{width:34px;height:34px;border:none;border-radius:9px;cursor:pointer;font-size:15px;
    display:inline-flex;align-items:center;justify-content:center;transition:transform 0.15s,box-shadow 0.15s}
  .action-btn:hover{transform:scale(1.18);box-shadow:0 4px 14px rgba(0,0,0,0.15)}
  .skeleton{background:linear-gradient(90deg,#f0f4ff 25%,#e8eeff 50%,#f0f4ff 75%);
    background-size:600px 100%;animation:shimmer 1.5s infinite;border-radius:6px}
  .nav-item{display:flex;align-items:center;gap:12px;padding-top:11px;padding-bottom:11px;
    padding-left:16px;padding-right:16px;cursor:pointer;border-radius:10px;margin:2px 10px;
    color:#aaa;font-size:14px;transition:all 0.15s;white-space:nowrap}
  .nav-item:hover{background:rgba(255,255,255,0.05);color:#fff}
  .nav-item.active{background:rgba(99,179,237,0.12);color:#63b3ed;border-left:3px solid #63b3ed;padding-left:13px}
  .cp-label{font-size:11px;font-weight:700;color:#718096;text-transform:uppercase;letter-spacing:0.5px;margin-bottom:6px;display:block}
  .badge{padding:4px 12px;border-radius:20px;font-size:12px;font-weight:600;display:inline-block}
  .dur-table{width:100%;border-collapse:collapse;border-radius:12px;overflow:hidden}
  .dur-table th{background:linear-gradient(135deg,#667eea,#764ba2);color:#fff;padding:10px 16px;
    font-size:11px;font-weight:700;text-transform:uppercase;letter-spacing:0.5px;text-align:left}
  .dur-table td{padding:10px 16px;font-size:13px;border-bottom:1px solid #f0f4ff;vertical-align:middle}
  .dur-table tr:last-child td{border-bottom:none}
  .dur-table tr:nth-child(even) td{background:#fafbff}
  .modal-scroll{overflow-y:auto;flex:1;padding:0 28px 20px}
  .modal-scroll::-webkit-scrollbar{width:5px}
  .modal-scroll::-webkit-scrollbar-thumb{background:#cbd5e0;border-radius:3px}
  .sec-div{display:flex;align-items:center;gap:12px;margin:20px 0 14px}
  .sec-div span{font-size:11px;font-weight:700;color:#a0aec0;text-transform:uppercase;letter-spacing:0.6px;white-space:nowrap}
  .sec-div::before,.sec-div::after{content:'';flex:1;height:1px;background:#e8eeff}
  .use-default-row{display:flex;align-items:center;gap:12px;padding:12px 16px;
    background:#f8faff;border:1.5px solid #e2e8f5;border-radius:12px;cursor:pointer;
    transition:all 0.2s;user-select:none}
  .use-default-row:hover{border-color:#63b3ed;background:#ebf8ff}
  .use-default-row.active{border-color:#63b3ed;background:#ebf8ff}
  .chk-box{width:20px;height:20px;border-radius:6px;border:2px solid #cbd5e0;
    display:flex;align-items:center;justify-content:center;flex-shrink:0;
    transition:all 0.18s;background:#fff}
  .chk-box.on{background:#63b3ed;border-color:#63b3ed}
  .chk-box.on::after{content:'✓';color:#fff;font-size:12px;font-weight:800}
`;

// const NAV = [
//   {icon:'⬡', label:'Dashboard',       path:'/dashboard'},
//   {icon:'👥', label:'User Management', path:'/user-management'},
//   {icon:'⏱️', label:'Rent Durations',  path:'/rent-durations'},
//   {icon:'💰', label:'Car Price',       path:'/car-price'},
//   {icon:'📋', label:'Bookings',        path:'/bookings'},
//   {icon:'🚘', label:'Vehicles',        path:'/vehicles'},
//   {icon:'👤', label:'Customers',       path:'/customers'},
//   {icon:'💳', label:'Payments',        path:'/payments'},
// ];

const EMPTY_FORM = {
  group_id:'', car_id:'', period_id:'', price:'',
  useDefault:false, duration_prices:[]
};

export default function CarPrice() {
  const navigate = useNavigate();
  const location = useLocation();

  const [authUser,    setAuthUser]    = useState(null);
  const [sideOpen,    setSideOpen]    = useState(true);

  // Dropdown data
  const [groups,      setGroups]      = useState([]);
  const [cars,        setCars]        = useState([]);
  const [seasons,     setSeasons]     = useState([]);
  const [rentDurs,    setRentDurs]    = useState([]);

  // Price list
  const [prices,      setPrices]      = useState([]);
  const [loading,     setLoading]     = useState(true);

  // Form
  const [form,        setForm]        = useState(EMPTY_FORM);
  const [editId,      setEditId]      = useState(null);
  const [saving,      setSaving]      = useState(false);
  const [carsLoading, setCarsLoading] = useState(false);

  // Modals
  const [viewModal,   setViewModal]   = useState(null);
  const [delModal,    setDelModal]    = useState(null);
  const [delSaving,   setDelSaving]   = useState(false);

  // Search / filter
  const [search,      setSearch]      = useState('');
  const [page,        setPage]        = useState(1);
  const [toast,       setToast]       = useState(null);
  const PER = 8;

  useEffect(() => {
    if (!localStorage.getItem('token')) { navigate('/login'); return; }
    setAuthUser(JSON.parse(localStorage.getItem('user') || '{}'));
    fetchMeta();
    fetchPrices();
  }, []);

  const fetchMeta = async () => {
    try {
      const [g, s, rd] = await Promise.all([
        API.get('/price/groups'),
        API.get('/price/seasons'),
        API.get('/price/rent-durations'),
      ]);
      setGroups(g.data);
      setSeasons(s.data);
      setRentDurs(rd.data);
      // Init duration_prices array
      setForm(p => ({
        ...p,
        duration_prices: rd.data.map(d => ({ RentslabId: d.RentslabId, discount: '' }))
      }));
    } catch(e) { showToast('Failed to load form data', 'error'); }
  };

  const fetchPrices = async () => {
    setLoading(true);
    try {
      const r = await API.get('/price');
      setPrices(r.data);
    } catch(e) { showToast('Failed to load prices', 'error'); }
    setLoading(false);
  };

  const loadCars = async (groupId) => {
    if (!groupId) { setCars([]); return; }
    setCarsLoading(true);
    try {
      const r = await API.get(`/price/cars/${groupId}`);
      setCars(r.data);
    } catch(e) { showToast('Failed to load cars', 'error'); }
    setCarsLoading(false);
  };

  const showToast = (msg, type='success') => {
    setToast({msg, type});
    setTimeout(() => setToast(null), 3500);
  };

  const resetForm = useCallback(() => {
    setForm({
      ...EMPTY_FORM,
      duration_prices: rentDurs.map(d => ({ RentslabId: d.RentslabId, discount: '' }))
    });
    setEditId(null);
    setCars([]);
  }, [rentDurs]);

  const startEdit = async (price) => {
    try {
      await loadCars(price.group_id);
      const r = await API.get(`/price/${price.tar_id}`);
      const rec = r.data;

      const dprices = rentDurs.map(d => {
        const found = rec.duration_prices.find(dp => dp.Rentslabid === d.RentslabId);
        return { RentslabId: d.RentslabId, discount: found ? found.discount : '' };
      });

      setForm({
        group_id:  String(rec.group_id),
        car_id:    String(rec.car_id),
        period_id: String(rec.period_id),
        price:     rec.price,
        useDefault: false,
        duration_prices: dprices,
      });
      setEditId(rec.tar_id);
      window.scrollTo({top:0, behavior:'smooth'});
    } catch(e) {
      showToast('Failed to load price for editing', 'error');
    }
  };

  const handleGroupChange = (gid) => {
    setForm(p => ({ ...p, group_id: gid, car_id: '' }));
    loadCars(gid);
  };

  const handlePriceChange = (val) => {
    setForm(p => {
      const updated = { ...p, price: val };
      if (p.useDefault) {
        updated.duration_prices = p.duration_prices.map(dp => ({ ...dp, discount: val }));
      }
      return updated;
    });
  };

  const handleUseDefault = () => {
    setForm(p => {
      const nowOn = !p.useDefault;
      return {
        ...p,
        useDefault: nowOn,
        duration_prices: p.duration_prices.map(dp => ({
          ...dp, discount: nowOn ? p.price : dp.discount
        }))
      };
    });
  };

  const handleDurPrice = (rentslabId, val) => {
    setForm(p => ({
      ...p,
      duration_prices: p.duration_prices.map(dp =>
        dp.RentslabId === rentslabId ? { ...dp, discount: val } : dp
      )
    }));
  };

  const handleSubmit = async () => {
    if (!form.group_id || !form.car_id || !form.period_id || !form.price) {
      showToast('Car Group, Car, Season and Price/Day are required', 'error'); return;
    }
    setSaving(true);
    try {
      const payload = {
        group_id:        form.group_id,
        car_id:          form.car_id,
        period_id:       form.period_id,
        price:           form.price,
        duration_prices: form.duration_prices,
      };
      if (editId) {
        await API.put(`/price/${editId}`, payload);
        showToast('Price updated successfully ✓');
      } else {
        await API.post('/price', payload);
        showToast('Price added successfully ✓');
      }
      await fetchPrices();
      resetForm();
    } catch(e) {
      showToast(e.response?.data?.message || 'Operation failed', 'error');
    }
    setSaving(false);
  };

  const handleDelete = async () => {
    setDelSaving(true);
    try {
      await API.delete(`/price/${delModal.tar_id}`);
      showToast('Price deleted successfully ✓');
      setDelModal(null);
      await fetchPrices();
    } catch(e) {
      showToast(e.response?.data?.message || 'Delete failed', 'error');
    }
    setDelSaving(false);
  };

  const formatDur = (rd) =>
    rd.ToRentslab === 1000 ? `${rd.FromRentslab}+ Days` : `${rd.FromRentslab}–${rd.ToRentslab} Days`;

  const filtered = prices.filter(p => {
    const q = search.toLowerCase();
    return !search ||
      p.car_name?.toLowerCase().includes(q) ||
      p.group_name?.toLowerCase().includes(q) ||
      p.period_name?.toLowerCase().includes(q);
  });
  const totalPages = Math.ceil(filtered.length / PER);
  const paged      = filtered.slice((page-1)*PER, page*PER);
  const logout     = () => { localStorage.clear(); navigate('/login'); };

  return (
    <Layout activePage="Car Price">
    <>
      <style>{STYLES}</style>
      <div style={S.root} className="cp-root">

        {/* ── Sidebar ── */}
        {/* <aside style={{...S.sidebar, width: sideOpen?220:68}}>
          <div style={S.sideTop}>
            <div style={S.logoWrap}>
              <div style={S.logoIcon}>🚗</div>
              {sideOpen && <span style={S.logoText}>Orisys</span>}
            </div>
            <button style={S.collapseBtn} onClick={()=>setSideOpen(p=>!p)}>
              {sideOpen?'◀':'▶'}
            </button>
          </div>
          <nav style={{flex:1}}>
            {NAV.map(n=>(
              <div key={n.label}
                className={`nav-item${location.pathname===n.path?' active':''}`}
                onClick={()=>navigate(n.path)}>
                <span style={{fontSize:16,flexShrink:0}}>{n.icon}</span>
                {sideOpen && <span style={{fontWeight:500}}>{n.label}</span>}
              </div>
            ))}
          </nav>
          <div style={S.sideBottom}>
            {sideOpen && (
              <div style={S.userChip}>
                <div style={S.avatar}>{authUser?.user_name?.[0]||'A'}</div>
                <div>
                  <div style={S.uname}>{authUser?.user_name||'Admin'}</div>
                  <div style={S.urole}>Administrator</div>
                </div>
              </div>
            )}
            <button style={S.logoutBtn} onClick={logout}>
              <span>🚪</span>{sideOpen&&<span style={{marginLeft:8}}>Logout</span>}
            </button>
          </div>
        </aside> */}

        {/* ── Main ── */}
        <main>

          {/* Page header */}
          <div style={S.pageHeader}>
            <div>
              <h1 style={S.pageTitle}>Car Price</h1>
              <p style={S.pageSub}>Manage pricing per car, season and rent duration</p>
            </div>
            <div style={{display:'flex',gap:12}}>
              {[
                {label:'Total Prices', value:prices.length, color:'#6C63FF', bg:'#f3f2ff', icon:'💰'},
                {label:'Car Groups',   value:groups.length, color:'#63b3ed', bg:'#ebf8ff', icon:'🚗'},
                {label:'Seasons',      value:seasons.length,color:'#48bb78', bg:'#f0fff4', icon:'🌤️'},
              ].map(s=>(
                <div key={s.label} style={{...S.miniStat, background:s.bg}}>
                  <span style={{fontSize:20}}>{s.icon}</span>
                  <div>
                    <div style={{fontSize:20,fontWeight:800,color:s.color,lineHeight:1}}>{s.value}</div>
                    <div style={{fontSize:10,color:'#718096',fontWeight:600,textTransform:'uppercase'}}>{s.label}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ── Add / Edit Form ── */}
          <div style={S.formCard}>
            <div style={S.formCardHead}>
              <div style={S.formCardIcon}>{editId?'✏️':'💰'}</div>
              <div style={{flex:1}}>
                <h2 style={S.formCardTitle}>{editId?'Edit Car Price':'Add Car Price'}</h2>
                <p style={S.formCardSub}>
                  {editId ? 'Modify pricing for the selected car and season' : 'Set base price and per-duration pricing'}
                </p>
              </div>
              {editId && (
                <button className="cp-btn-secondary" onClick={resetForm}>✕ Cancel</button>
              )}
            </div>

            {/* Row 1 — Dropdowns */}
            <div style={S.formGrid3}>
              <div>
                <label className="cp-label">Car Group *</label>
                <select className="cp-select" value={form.group_id}
                  onChange={e=>handleGroupChange(e.target.value)}>
                  <option value="">— Select Group —</option>
                  {groups.map(g=>(
                    <option key={g.group_id} value={g.group_id}>{g.group_name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="cp-label">Car *</label>
                <select className="cp-select" value={form.car_id}
                  disabled={!form.group_id || carsLoading}
                  onChange={e=>setForm(p=>({...p,car_id:e.target.value}))}>
                  <option value="">
                    {carsLoading ? 'Loading…' : form.group_id ? '— Select Car —' : '— Select Group First —'}
                  </option>
                  {cars.map(c=>(
                    <option key={c.car_id} value={c.car_id}>{c.car_name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="cp-label">Season *</label>
                <select className="cp-select" value={form.period_id}
                  onChange={e=>setForm(p=>({...p,period_id:e.target.value}))}>
                  <option value="">— Select Season —</option>
                  {seasons.map(s=>(
                    <option key={s.period_id} value={s.period_id}>{s.period_name}</option>
                  ))}
                </select>
              </div>
            </div>

            {/* Row 2 — Price/Day + Use Default */}
            <div style={{...S.formGrid3, marginTop:16}}>
              <div>
                <label className="cp-label">Price / Day *</label>
                <div style={{position:'relative'}}>
                  <span style={{position:'absolute',left:14,top:'50%',transform:'translateY(-50%)',
                    color:'#48bb78',fontWeight:800,fontSize:15}}>₹</span>
                  <input className="cp-input" type="number" min="0" step="0.01"
                    placeholder="0.00" value={form.price}
                    onChange={e=>handlePriceChange(e.target.value)}
                    style={{paddingLeft:32}}/>
                </div>
              </div>
              <div style={{gridColumn:'2/-1',display:'flex',alignItems:'flex-end'}}>
                <div className={`use-default-row${form.useDefault?' active':''}`}
                  style={{flex:1}} onClick={handleUseDefault}>
                  <div className={`chk-box${form.useDefault?' on':''}`}/>
                  <div>
                    <div style={{fontWeight:600,fontSize:14,color:form.useDefault?'#2b6cb0':'#4a5568'}}>
                      Use Price/Day as Default for All Durations
                    </div>
                    <div style={{fontSize:12,color:'#a0aec0',marginTop:2}}>
                      {form.useDefault
                        ? `All duration prices set to ₹${form.price||'0'}`
                        : 'Click to auto-fill all duration prices with base price'}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Duration price table */}
            {rentDurs.length > 0 && (
              <>
                <div className="sec-div"><span>Price per Rent Duration</span></div>
                <div style={{borderRadius:14,overflow:'hidden',border:'1.5px solid #e8eeff'}}>
                  <table className="dur-table">
                    <thead>
                      <tr>
                        <th>Duration Slab</th>
                        <th>Range</th>
                        <th>Price (₹)</th>
                        <th>vs Base</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rentDurs.map((rd, i) => {
                        const dp = form.duration_prices.find(d => d.RentslabId === rd.RentslabId);
                        const val = dp ? dp.discount : '';
                        const base = parseFloat(form.price) || 0;
                        const curr = parseFloat(val) || 0;
                        const diff = base > 0 ? ((curr - base) / base * 100).toFixed(0) : null;
                        return (
                          <tr key={rd.RentslabId}>
                            <td>
                              <div style={{display:'flex',alignItems:'center',gap:10}}>
                                <div style={{width:32,height:32,borderRadius:8,
                                  background:`hsl(${200+i*20},70%,90%)`,
                                  display:'flex',alignItems:'center',justifyContent:'center',
                                  fontWeight:800,fontSize:13,color:`hsl(${200+i*20},60%,35%)`}}>
                                  {i+1}
                                </div>
                                <span style={{fontWeight:600,color:'#1a1d2e',fontSize:13}}>
                                  Slab {i+1}
                                </span>
                              </div>
                            </td>
                            <td>
                              <span style={{background:'#f0f4ff',color:'#4a5568',
                                padding:'4px 10px',borderRadius:20,fontSize:12,fontWeight:600}}>
                                {formatDur(rd)}
                              </span>
                            </td>
                            <td>
                              <div style={{display:'flex',alignItems:'center',gap:6}}>
                                <span style={{color:'#48bb78',fontWeight:800}}>₹</span>
                                <input className="cp-input small" type="number"
                                  min="0" step="0.01" placeholder="0.00"
                                  value={val}
                                  style={{width:100}}
                                  onChange={e=>handleDurPrice(rd.RentslabId, e.target.value)}
                                />
                              </div>
                            </td>
                            <td>
                              {diff !== null && val !== '' ? (
                                <span style={{
                                  padding:'3px 10px',borderRadius:20,fontSize:12,fontWeight:700,
                                  background: diff==0?'#f0f4ff':diff<0?'#f0fff4':'#fff5f5',
                                  color: diff==0?'#718096':diff<0?'#276749':'#c53030'
                                }}>
                                  {diff==0?'= Base':diff<0?`${diff}%`:`+${diff}%`}
                                </span>
                              ) : (
                                <span style={{color:'#cbd5e0',fontSize:12}}>—</span>
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </>
            )}

            {/* Submit */}
            <div style={{display:'flex',gap:12,marginTop:20,justifyContent:'flex-end'}}>
              {editId && (
                <button className="cp-btn-secondary" onClick={resetForm}>Cancel</button>
              )}
              <button className="cp-btn-primary" onClick={handleSubmit} disabled={saving}>
                {saving
                  ? <span style={S.spinner}/>
                  : editId ? '💾 Update Price' : '＋ Add Price'}
              </button>
            </div>
          </div>

          {/* ── Manage Price Table ── */}
          <div style={S.tableCard}>
            <div style={S.tableCardHead}>
              <h3 style={S.tableCardTitle}>📋 Manage Prices</h3>
              <div style={{display:'flex',gap:12,alignItems:'center'}}>
                <div style={{position:'relative'}}>
                  <span style={{position:'absolute',left:12,top:'50%',transform:'translateY(-50%)',
                    color:'#a0aec0',fontSize:14,pointerEvents:'none'}}>🔍</span>
                  <input style={{padding:'8px 14px 8px 36px',border:'1.5px solid #e2e8f5',
                    borderRadius:20,background:'#fff',fontSize:13,outline:'none',
                    width:220,fontFamily:'DM Sans,sans-serif',color:'#1a1d2e'}}
                    placeholder="Search car, group, season…"
                    value={search} onChange={e=>{setSearch(e.target.value);setPage(1);}}/>
                </div>
                <span style={{fontSize:12,background:'#f3f2ff',color:'#6C63FF',
                  borderRadius:20,padding:'4px 14px',fontWeight:700}}>
                  {filtered.length} records
                </span>
              </div>
            </div>

            <div style={{overflowX:'auto'}}>
              <table style={S.table}>
                <thead>
                  <tr style={{background:'linear-gradient(135deg,#f8faff,#f0f4ff)'}}>
                    {['#','Car Group','Car','Season','Base Price/Day','Durations','Actions'].map(h=>(
                      <th key={h} style={S.th}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {loading
                    ? Array.from({length:5}).map((_,i)=>(
                        <tr key={i}>
                          {Array.from({length:7}).map((_,j)=>(
                            <td key={j} style={S.td}><div className="skeleton" style={{height:14,width:'70%'}}/></td>
                          ))}
                        </tr>
                      ))
                    : paged.length===0
                    ? (
                        <tr>
                          <td colSpan={7} style={{textAlign:'center',padding:'48px 0',color:'#a0aec0'}}>
                            <div style={{fontSize:40,marginBottom:10}}>💰</div>
                            <div style={{fontSize:15,fontWeight:600}}>No prices added yet</div>
                            <div style={{fontSize:13,marginTop:4}}>Use the form above to add pricing</div>
                          </td>
                        </tr>
                      )
                    : paged.map((p, i)=>(
                        <tr key={p.tar_id} className="cp-row"
                          style={{borderBottom:'1px solid #f0f4ff',
                            background:editId===p.tar_id?'#fffbf0':i%2===0?'#fff':'#fafbff'}}>
                          <td style={{...S.td,color:'#a0aec0',fontWeight:700,fontSize:12}}>
                            {(page-1)*PER+i+1}
                          </td>
                          <td style={S.td}>
                            <span className="badge" style={{background:'#ebf8ff',color:'#2b6cb0'}}>
                              🚗 {p.group_name}
                            </span>
                          </td>
                          <td style={S.td}>
                            <div style={{fontWeight:600,color:'#1a1d2e',fontSize:14}}>{p.car_name}</div>
                          </td>
                          <td style={S.td}>
                            <span className="badge" style={{background:'#f0fff4',color:'#276749'}}>
                              🌤️ {p.period_name}
                            </span>
                          </td>
                          <td style={S.td}>
                            <div style={{fontWeight:800,fontSize:16,color:'#48bb78'}}>
                              ₹{parseFloat(p.price).toLocaleString()}
                            </div>
                            <div style={{fontSize:11,color:'#a0aec0'}}>per day</div>
                          </td>
                          <td style={S.td}>
                            <span className="badge" style={{background:'#f3f2ff',color:'#6C63FF',cursor:'pointer'}}
                              onClick={()=>setViewModal(p)}>
                              {p.duration_prices?.length||0} slabs →
                            </span>
                          </td>
                          <td style={S.td}>
                            <div style={{display:'flex',gap:6}}>
                              <button className="action-btn" style={{background:'#ebf8ff',color:'#2b6cb0'}}
                                title="View" onClick={()=>setViewModal(p)}>👁</button>
                              <button className="action-btn" style={{background:'#fefcbf',color:'#744210'}}
                                title="Edit" onClick={()=>startEdit(p)}>✏️</button>
                              <button className="action-btn" style={{background:'#fff5f5',color:'#c53030'}}
                                title="Delete" onClick={()=>setDelModal(p)}>🗑</button>
                            </div>
                          </td>
                        </tr>
                      ))
                  }
                </tbody>
              </table>
            </div>

            {/* Pagination */}
            {totalPages > 1 && (
              <div style={S.pagination}>
                <span style={{fontSize:13,color:'#718096'}}>
                  Showing {(page-1)*PER+1}–{Math.min(page*PER,filtered.length)} of {filtered.length}
                </span>
                <div style={{display:'flex',gap:6}}>
                  <button style={S.pageBtn} disabled={page===1} onClick={()=>setPage(p=>p-1)}>← Prev</button>
                  {Array.from({length:totalPages},(_,i)=>i+1).map(p=>(
                    <button key={p} style={{...S.pageBtn,...(p===page?S.pageBtnActive:{})}}
                      onClick={()=>setPage(p)}>{p}</button>
                  ))}
                  <button style={S.pageBtn} disabled={page===totalPages} onClick={()=>setPage(p=>p+1)}>Next →</button>
                </div>
              </div>
            )}
          </div>
        </main>

        {/* ── View Modal ── */}
        {viewModal && (
          <div style={S.overlay} onClick={()=>setViewModal(null)}>
            <div style={{...S.modal,maxWidth:560}} onClick={e=>e.stopPropagation()}>
              <div style={S.modalHead}>
                <div>
                  <h2 style={S.modalTitle}>💰 Price Details</h2>
                  <p style={S.modalSub}>{viewModal.car_name} · {viewModal.period_name}</p>
                </div>
                <button style={S.xBtn} onClick={()=>setViewModal(null)}>✕</button>
              </div>
              <div className="modal-scroll">
                {/* Summary */}
                <div style={{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:12,marginBottom:20}}>
                  {[
                    {label:'Car Group', value:viewModal.group_name, icon:'🚗'},
                    {label:'Car',       value:viewModal.car_name,   icon:'🏎️'},
                    {label:'Season',    value:viewModal.period_name, icon:'🌤️'},
                  ].map(r=>(
                    <div key={r.label} style={{background:'#f8faff',borderRadius:12,
                      padding:'12px 14px',border:'1.5px solid #e8eeff'}}>
                      <div style={{fontSize:11,color:'#a0aec0',fontWeight:600,
                        textTransform:'uppercase',letterSpacing:'0.4px',marginBottom:4}}>{r.icon} {r.label}</div>
                      <div style={{fontSize:14,fontWeight:700,color:'#1a1d2e'}}>{r.value}</div>
                    </div>
                  ))}
                </div>

                {/* Base price */}
                <div style={{background:'linear-gradient(135deg,#f0fff4,#e6fffa)',
                  borderRadius:14,padding:'16px 20px',border:'1.5px solid #9ae6b4',
                  display:'flex',alignItems:'center',justifyContent:'space-between',marginBottom:20}}>
                  <div>
                    <div style={{fontSize:12,color:'#276749',fontWeight:600,textTransform:'uppercase',
                      letterSpacing:'0.5px'}}>Base Price / Day</div>
                    <div style={{fontSize:28,fontWeight:800,color:'#276749',lineHeight:1,marginTop:4}}>
                      ₹{parseFloat(viewModal.price).toLocaleString()}
                    </div>
                  </div>
                  <div style={{fontSize:36}}>💰</div>
                </div>

                {/* Duration prices */}
                <div className="sec-div"><span>Duration Pricing</span></div>
                {viewModal.duration_prices?.length > 0 ? (
                  <div style={{borderRadius:12,overflow:'hidden',border:'1.5px solid #e8eeff'}}>
                    <table className="dur-table">
                      <thead>
                        <tr>
                          <th>Duration Range</th>
                          <th>Price / Day</th>
                          <th>vs Base</th>
                        </tr>
                      </thead>
                      <tbody>
                        {viewModal.duration_prices.map((dp, i) => {
                          const base = parseFloat(viewModal.price) || 0;
                          const curr = parseFloat(dp.discount) || 0;
                          const diff = base > 0 ? ((curr - base) / base * 100).toFixed(0) : 0;
                          return (
                            <tr key={i}>
                              <td>
                                <span style={{background:'#f0f4ff',color:'#4a5568',
                                  padding:'4px 10px',borderRadius:20,fontSize:12,fontWeight:600}}>
                                  {dp.FromRentslab === 1000
                                    ? `${dp.FromRentslab}+ Days`
                                    : `${dp.FromRentslab}–${dp.ToRentslab === 1000 ? '∞' : dp.ToRentslab} Days`}
                                </span>
                              </td>
                              <td style={{fontWeight:700,color:'#48bb78',fontSize:15}}>
                                ₹{parseFloat(dp.discount).toLocaleString()}
                              </td>
                              <td>
                                <span style={{padding:'3px 10px',borderRadius:20,fontSize:12,fontWeight:700,
                                  background:diff==0?'#f0f4ff':diff<0?'#f0fff4':'#fff5f5',
                                  color:diff==0?'#718096':diff<0?'#276749':'#c53030'}}>
                                  {diff==0?'= Base':diff<0?`${diff}%`:`+${diff}%`}
                                </span>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                ) : (
                  <div style={{textAlign:'center',padding:'20px',color:'#a0aec0',fontSize:13,
                    background:'#f8faff',borderRadius:12}}>
                    No duration pricing configured
                  </div>
                )}
              </div>
              <div style={S.modalFoot}>
                <button className="cp-btn-secondary" onClick={()=>setViewModal(null)}>Close</button>
                <button className="cp-btn-primary"
                  onClick={()=>{setViewModal(null);setTimeout(()=>startEdit(viewModal),100);}}>
                  ✏️ Edit Price
                </button>
              </div>
            </div>
          </div>
        )}

        {/* ── Delete Modal ── */}
        {delModal && (
          <div style={S.overlay} onClick={()=>setDelModal(null)}>
            <div style={{...S.modal,maxWidth:420}} onClick={e=>e.stopPropagation()}>
              <div style={{padding:'36px 32px',textAlign:'center'}}>
                <div style={{fontSize:52,marginBottom:16}}>🗑️</div>
                <h2 style={{fontSize:20,fontWeight:800,color:'#1a1d2e',marginBottom:8}}>Delete Price?</h2>
                <div style={{marginBottom:16,display:'flex',gap:8,justifyContent:'center',flexWrap:'wrap'}}>
                  <span className="badge" style={{background:'#ebf8ff',color:'#2b6cb0'}}>{delModal.car_name}</span>
                  <span className="badge" style={{background:'#f0fff4',color:'#276749'}}>{delModal.period_name}</span>
                  <span className="badge" style={{background:'#f3f2ff',color:'#6C63FF'}}>₹{delModal.price}/day</span>
                </div>
                <p style={{color:'#718096',fontSize:14,lineHeight:1.7,marginBottom:28}}>
                  This will also delete all duration pricing for this entry.<br/>
                  <strong style={{color:'#e53e3e'}}>This action cannot be undone.</strong>
                </p>
                <div style={{display:'flex',gap:12,justifyContent:'center'}}>
                  <button className="cp-btn-secondary" onClick={()=>setDelModal(null)}>Cancel</button>
                  <button disabled={delSaving} onClick={handleDelete} style={{
                    padding:'12px 24px',background:'linear-gradient(135deg,#fc8181,#e53e3e)',
                    border:'none',borderRadius:12,color:'#fff',fontWeight:700,fontSize:14,
                    fontFamily:'DM Sans,sans-serif',cursor:'pointer',
                    display:'flex',alignItems:'center',gap:8}}>
                    {delSaving?<span style={S.spinner}/>:'🗑️ Delete Permanently'}
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {/* ── Toast ── */}
        {toast && (
          <div style={{...S.toast,
            background:toast.type==='error'?'#fff5f5':'#f0fff4',
            borderColor:toast.type==='error'?'#fc8181':'#68d391',
            color:toast.type==='error'?'#c53030':'#276749'}}>
            {toast.type==='error'?'⚠️':'✅'} {toast.msg}
          </div>
        )}
      </div>
    </>
    </Layout>
  );
}

const S = {
  root:{display:'flex',minHeight:'100vh',background:'#f4f6fb'},
//   sidebar:{background:'#1a1d2e',color:'#fff',display:'flex',flexDirection:'column',
//     position:'fixed',height:'100vh',transition:'width 0.25s',overflow:'hidden',zIndex:100,borderRadius: '0 10px 10px 0',position:'sticky',top:'0'},
//   sideTop:{display:'flex',alignItems:'center',justifyContent:'space-between',padding:'20px 16px 16px'},
//   logoWrap:{display:'flex',alignItems:'center',gap:10},
//   logoIcon:{width:36,height:36,background:'linear-gradient(135deg,#63b3ed,#4299e1)',borderRadius:10,
//     display:'flex',alignItems:'center',justifyContent:'center',fontSize:18,flexShrink:0},
//   logoText:{fontSize:18,fontWeight:800,letterSpacing:'-0.5px',whiteSpace:'nowrap',fontFamily:"'Syne',sans-serif"},
//   collapseBtn:{background:'rgba(255,255,255,0.08)',border:'none',color:'#aaa',borderRadius:6,
//     padding:'4px 8px',cursor:'pointer',fontSize:11,flexShrink:0},
//   sideBottom:{padding:'16px',borderTop:'1px solid rgba(255,255,255,0.07)'},
//   userChip:{display:'flex',alignItems:'center',gap:10,marginBottom:12},
//   avatar:{width:36,height:36,background:'linear-gradient(135deg,#63b3ed,#4299e1)',borderRadius:'50%',
//     display:'flex',alignItems:'center',justifyContent:'center',fontWeight:800,fontSize:15,flexShrink:0},
//   uname:{fontSize:13,fontWeight:700,color:'#fff'},
//   urole:{fontSize:11,color:'#777'},
//   logoutBtn:{width:'100%',background:'rgba(255,100,100,0.12)',border:'1px solid rgba(255,100,100,0.2)',
//     color:'#ff6b6b',borderRadius:8,padding:'8px 12px',cursor:'pointer',fontSize:13,
//     display:'flex',alignItems:'center',justifyContent:'center',fontFamily:'inherit'},

  main:{flex:1,padding:'28px',minWidth:0},
  pageHeader:{display:'flex',justifyContent:'space-between',alignItems:'flex-start',marginBottom:24,flexWrap:'wrap',gap:16},
  pageTitle:{fontSize:26,fontWeight:800,color:'#1a1d2e',letterSpacing:'-0.5px',margin:0,fontFamily:"'Syne',sans-serif"},
  pageSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},
  miniStat:{display:'flex',alignItems:'center',gap:12,borderRadius:14,padding:'14px 18px',
    boxShadow:'0 2px 10px rgba(0,0,0,0.05)'},

  formCard:{background:'#fff',borderRadius:20,padding:'28px',
    boxShadow:'0 4px 24px rgba(0,0,0,0.07)',marginBottom:24,border:'1.5px solid #e8eeff'},
  formCardHead:{display:'flex',alignItems:'flex-start',gap:16,marginBottom:22},
  formCardIcon:{width:48,height:48,background:'linear-gradient(135deg, rgb(244, 246, 251), rgb(56, 161, 105))',
    borderRadius:14,display:'flex',alignItems:'center',justifyContent:'center',
    fontSize:22,flexShrink:0,boxShadow:'0 4px 14px rgba(72,187,120,0.35)'},
  formCardTitle:{fontSize:18,fontWeight:800,color:'#1a1d2e',margin:0,fontFamily:"'Syne',sans-serif"},
  formCardSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},
  formGrid3:{display:'grid',gridTemplateColumns:'1fr 1fr 1fr',gap:16},

  tableCard:{background:'#fff',borderRadius:20,overflow:'hidden',
    boxShadow:'0 4px 24px rgba(0,0,0,0.07)',marginBottom:20,border:'1.5px solid #e8eeff'},
  tableCardHead:{display:'flex',justifyContent:'space-between',alignItems:'center',
    padding:'20px 24px',borderBottom:'1px solid #f0f4ff',flexWrap:'wrap',gap:12},
  tableCardTitle:{fontSize:16,fontWeight:800,color:'#1a1d2e',margin:0,fontFamily:"'Syne',sans-serif"},
  table:{width:'100%',borderCollapse:'collapse'},
  th:{padding:'14px 20px',fontSize:11,fontWeight:700,color:'#718096',textAlign:'left',
    textTransform:'uppercase',letterSpacing:'0.5px',borderBottom:'2px solid #e8eeff'},
  td:{padding:'14px 20px',fontSize:13,color:'#4a5568',verticalAlign:'middle'},

  pagination:{display:'flex',justifyContent:'space-between',alignItems:'center',
    padding:'16px 24px',borderTop:'1px solid #f0f4ff'},
  pageBtn:{padding:'6px 12px',border:'1.5px solid #e2e8f5',borderRadius:8,background:'#fff',
    color:'#718096',fontSize:13,fontWeight:600,cursor:'pointer',
    fontFamily:'DM Sans,sans-serif',transition:'all 0.15s'},
  pageBtnActive:{background:'#63b3ed',borderColor:'#63b3ed',color:'#fff'},

  overlay:{position:'fixed',inset:0,background:'rgba(10,15,40,0.6)',zIndex:200,
    display:'flex',alignItems:'center',justifyContent:'center',backdropFilter:'blur(4px)',padding:'20px'},
  modal:{background:'#fff',borderRadius:20,width:'100%',maxWidth:620,maxHeight:'90vh',
    display:'flex',flexDirection:'column',
    boxShadow:'0 32px 80px rgba(0,0,0,0.25)',animation:'modalIn 0.3s ease both'},
  modalHead:{display:'flex',justifyContent:'space-between',alignItems:'flex-start',
    padding:'24px 28px 0',flexShrink:0},
  modalTitle:{fontSize:20,fontWeight:800,color:'#1a1d2e',margin:0,fontFamily:"'Syne',sans-serif"},
  modalSub:{fontSize:13,color:'#a0aec0',margin:'4px 0 0'},
  modalFoot:{display:'flex',gap:12,justifyContent:'flex-end',
    padding:'16px 28px',borderTop:'1px solid #f0f4ff',flexShrink:0},
  xBtn:{background:'rgba(255,107,107,0.1)',border:'none',color:'#fc8181',borderRadius:'50%',
    width:32,height:32,cursor:'pointer',fontWeight:800,fontSize:14,
    display:'flex',alignItems:'center',justifyContent:'center'},

  spinner:{display:'inline-block',width:16,height:16,border:'2px solid rgba(255,255,255,0.3)',
    borderTopColor:'#fff',borderRadius:'50%',animation:'spin 0.6s linear infinite'},
  toast:{position:'fixed',top:700,right:28,zIndex:999,padding:'14px 22px',
    borderRadius:12,border:'1.5px solid',fontSize:14,fontWeight:600,
    fontFamily:'DM Sans,sans-serif',boxShadow:'0 8px 24px rgba(0,0,0,0.1)',
    animation:'fadeSlideIn 0.3s ease'},
};